import { createContext } from 'react';
import { emptyFn } from '@/lib/utils';
import type { Theme } from '../theme-context/theme-context';

export type ScrollAction = 'pan' | 'zoom';

export interface LocalConfigContext {
  theme: Theme;
  setTheme: (theme: Theme) => void;

  scrollAction: ScrollAction;
  setScrollAction: (action: ScrollAction) => void;

  githubRepoOpened: boolean;
  setGithubRepoOpened: (githubRepoOpened: boolean) => void;

  starUsDialogLastOpen: number;
  setStarUsDialogLastOpen: (lastOpen: number) => void;
}

export const LocalConfigContext = createContext<LocalConfigContext>({
  theme: 'system',
  setTheme: emptyFn,

  scrollAction: 'pan',
  setScrollAction: emptyFn,

  githubRepoOpened: false,
  setGithubRepoOpened: emptyFn,

  starUsDialogLastOpen: 0,
  setStarUsDialogLastOpen: emptyFn,
});
